export const buttonMessages = {
  confirm: 'Xác nhận',
  feedback: 'Phản hồi'
};
